const template = document.createElement('template')
template.innerHTML = `
  <wa-tree-item class="dropdown-item">
    <slot></slot>
  </wa-tree-item>
`

class NavHeaderContextualMenuItem extends HTMLElement {
  
  connectedCallback() {
    const item = document.createElement('wa-tree-item')
    item.className = 'dropdown-item'

    for (const attr of this.getAttributeNames()) {
      item.setAttribute(attr, this.getAttribute(attr)!)
    }

    while (this.firstChild) item.appendChild(this.firstChild)
    this.replaceWith(item)
  }
}


customElements.define('ts-navheader-contextual-menu-item', NavHeaderContextualMenuItem)
